import { IFilterCalendarByDate } from '../../../actions/bookingCalendar/filtering/filterByDate'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IFilterCalendarByDate,
): IBookingCalendarStore {
  return {
    ...state,
    filtering: {
      ...state.filtering,
      byDate: {
        from: action.from,
        to: action.to,
      },
    },
  }
}
